module.exports = __webpack_public_path__ + "img/undraw_floating_61u6.ea75d4a3.svg";